import { render } from "./EventsFullPage.vue?vue&type=template&id=d578e738&ts=true"
import script from "./EventsFullPage.vue?vue&type=script&lang=ts"
export * from "./EventsFullPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/events/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__